import { Box } from '@mui/material';
import React from 'react';
import { FileProgress, MediaItemDetailed } from '../../types';
import { CMButton } from '../common/CMButton';

interface UploadButtonProps {
  items: MediaItemDetailed[];
  onUpload: () => Promise<void>;
  disabled?: boolean;
  uploadProgress: Record<string, FileProgress>;
}

export const UploadButton: React.FC<UploadButtonProps> = ({ 
  items, 
  onUpload, 
  disabled,
  uploadProgress 
}) => {
  if (items.length === 0) return null;

  const uploadingCount = Object.values(uploadProgress).filter(p => !p.completed).length;
  const completedCount = Object.values(uploadProgress).filter(p => p.completed).length;

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    // Add a small delay to ensure UI is updated first
    setTimeout(() => {
      onUpload();
    }, 100);
  };

  return (
    <Box>
      <CMButton
        onClick={handleClick}
        variant="outlined"
        color="primary"
        disabled={disabled}
        sx={{ minWidth: '120px' }}
      >
        {uploadingCount > 0 
          ? `Uploading... (${completedCount}/${items.length})`
          : `Upload Files (${items.length})`
        }
      </CMButton>
    </Box>
  );
}; 